// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @actions
const modifyCommerceAndATMLimitsActions = require('actions/contactCenter/modifyCommerceAndATMLimits//modifyCommerceAndATMLimits');

const ModifyCommerceAndATMLimitsView = require('components/contactCenter/modifyCommerceAndATMLimits//modifyCommerceAndATMLimitsView');

class ModifyCommerceAndATMLimitsContainer extends React.Component {
    componentDidMount() {
        const { match: { params: { cardId, type } }, limitsDataRequest } = this.props;

        limitsDataRequest(cardId, type);
    }

    render() {
        const { match: { params: { cardId } }, immCards } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        return <ModifyCommerceAndATMLimitsView immCard={immCard} {...this.props} />;
    }
}

ModifyCommerceAndATMLimitsContainer.propTypes = {
    immModifyCommerceAndATMLimits: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    setLimitAmount: PropTypes.func.isRequired,
    setLimitRanges: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    limitsDataRequest: PropTypes.func.isRequired,
    immCards: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    immModifyCommerceAndATMLimits: state.modifyCommerceAndATMLimits,
    immCards: state.cards
});

module.exports.constructor = ModifyCommerceAndATMLimitsContainer;
module.exports.ModifyCommerceAndATMLimitsContainer = connect(
    mapStateToProps,
    {
        setVisibleStep: modifyCommerceAndATMLimitsActions.setVisibleStep,
        validateStep: modifyCommerceAndATMLimitsActions.validateStep,
        showCancelModal: modifyCommerceAndATMLimitsActions.showCancelModal,
        reset: modifyCommerceAndATMLimitsActions.reset,
        confirmModifyCommerceAndATMLimits: modifyCommerceAndATMLimitsActions.confirmModifyCommerceAndATMLimits,
        limitsDataRequest: modifyCommerceAndATMLimitsActions.limitsDataRequest,
        setLimitAmount: modifyCommerceAndATMLimitsActions.setLimitAmount,
        setLimitRanges: modifyCommerceAndATMLimitsActions.setLimitRanges,
        hideWarningModal: modifyCommerceAndATMLimitsActions.hideWarningModal
    }
)(ModifyCommerceAndATMLimitsContainer);
